var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modpack--controls" }, [
    _vm.useLeft
      ? _c(
          "div",
          {
            staticClass: "modpack--controls-left",
            on: {
              click: function ($event) {
                return _vm.emit("previous")
              },
            },
          },
          [
            _c("font-awesome-icon", {
              staticClass: "modpack--controls-icon",
              attrs: { icon: ["fas", "chevron-left"] },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.useRight
      ? _c(
          "div",
          {
            staticClass: "modpack--controls-right",
            on: {
              click: function ($event) {
                return _vm.emit("next")
              },
            },
          },
          [
            _c("font-awesome-icon", {
              staticClass: "modpack--controls-icon",
              attrs: { icon: ["fas", "chevron-right"] },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }